/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Данные для обновления документа ВК.
 */
export interface StatementUpdate {
  /**
   * Идентификатор ответственного лица по сделке
   * @format uuid
   */
  responsiblePersonId?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /**
   * Идентификатор контракта
   * @format uuid
   */
  contractId?: string;

  /** Уникальный номер договора ВЭД */
  regUNK?: string;

  /** Запрошен ли ВБК по УНК */
  regVBK?: boolean;

  /** Запрошен ли раздел 1 ВБК по УНК */
  regVBK1?: boolean;

  /** Номер договора ВЭД, не поставленного на учет в Банке */
  contractNum?: string;

  /**
   * Дата договора ВЭД, не поставленного на учет в Банке
   * @format date
   */
  contractDate?: string;

  /** Если запрошен иной документ по УНК, передается перечень документов */
  regDocs?: string;
}

/**
 * Квиток о создании документа.
 */
export interface StatementResponse {
  /**
   * Идентификатор созданного/отредактированного документа
   * @format uuid
   */
  documentId?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Данные для создания документа ВК.
 */
export interface StatementRequest {
  /**
   * Идентификатор ответственного лица по сделке
   * @format uuid
   */
  responsiblePersonId?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFIO?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /**
   * Идентификатор контракта
   * @format uuid
   */
  contractId?: string;

  /** Уникальный номер договора ВЭД */
  regUNK?: string;

  /** Запрошен ли ВБК по УНК */
  regVBK?: boolean;

  /** Запрошен ли раздел 1 ВБК по УНК */
  regVBK1?: boolean;

  /** Номер договора ВЭД, не поставленного на учет в Банке */
  contractNum?: string;

  /**
   * Дата договора ВЭД, не поставленного на учет в Банке
   * @format date
   */
  contractDate?: string;

  /** Если запрошен иной документ по УНК, передается перечень документов */
  regDocs?: string;
}

/**
 * Документ
 */
export interface ClientStatement {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date
   */
  documentDate?: string;

  /** Статус выполнения документа */
  state?: string;

  /** Наименование филиала Банка Клиента, в рамках которого создан и обслуживается документ */
  branchName?: string;

  /** Код филиала Банка Клиента, в рамках которого создан и обслуживается документ */
  branchCode?: string;

  /** Признак наличия вложений */
  isAttachment?: boolean;

  /**
   * Дата и время обновления записи
   * @format date-time
   */
  lastUpdate?: string;

  /** Уникальный номер договора ВЭД */
  unk?: string;

  /** Номер договора ВЭД, не поставленного на учет в Банке */
  contractNum?: string;

  /**
   * Дата договора ВЭД, не поставленного на учет в Банке
   * @format date
   */
  contractDate?: string;

  /**
   * Id договора ВЭД
   * @format uuid
   */
  contractId?: string;

  /** Полномочия */
  permissions?: PermissionResponse[];
}

/**
 * Ответ со списком документов
 */
export interface ClientStatementResponseList {
  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Наименование Клиента */
  clientName?: string;

  /** ИНН Клиента */
  clientInn?: string;

  /** КПП Клиента */
  clientKpp?: string;

  /** Информация о пагинации */
  page?: Page;
  statements?: ClientStatement[];
}

/**
 * Информация о пагинации
 */
export interface Page {
  /**
   * Количество страниц в выборке
   * @format int32
   */
  totalPages?: number;

  /**
   * Количество всех записей в выборке (без учёта пагинации)
   * @format int32
   */
  totalRows?: number;

  /**
   * Номер страницы
   * @format int32
   */
  number?: number;

  /**
   * Количество записей на странице
   * @format int32
   */
  size?: number;
}

/**
 * Разрешение на документ
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  description?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Вложение к документу
 */
export interface Attachment {
  /**
   * Идентификатор файла в МС
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор файла в ФХ
   * @format uuid
   */
  extId?: string;

  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  fileSize?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хэш-сумма файла */
  hash?: string;

  /** Состояние заливки файла */
  ready?: boolean;

  /** Код ошибки заливки файла */
  errorCode?: string;

  /** Описание ошибки заливки файла */
  errorDescription?: string;
}

/**
 * Детальная информация о документе
 */
export interface ClientStatementResponseDetail {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор ответственного лица по сделке
   * @format uuid
   */
  responsiblePersonId?: string;

  /** ФИО ответственного лица по сделке */
  responsiblePersonFio?: string;

  /** Телефон ответственного лица по сделке */
  responsiblePersonPhone?: string;

  /** Статус документа */
  state?: string;

  /** Код филиала Банка Клиента, в рамках которого создан и обслуживается докумен */
  branchCode?: string;

  /** Наименование филиала Банка Клиента, в рамках которого создан и обслуживается документ */
  branchName?: string;

  /**
   * Идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Наименование Клиента */
  clientName?: string;

  /** ИНН Клиента */
  clientInn?: string;

  /** КПП Клиента */
  clientKpp?: string;

  /**
   * Идентификатор документа Отзыв, созданного к данному документу
   * @format uuid
   */
  revokeId?: string;

  /**
   * Дата и время создания записи
   * @format date-time
   */
  createDate?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Номер документа */
  documentNumber?: string;

  /** Уникальный номер договора ВЭД */
  unk?: string;

  /** Запрошен ли ВБК по УНК */
  regVbk?: boolean;

  /** Запрошен ли раздел 1 ВБК по УНК */
  regVbk1?: boolean;

  /** Перечень документов */
  regDocs?: string;

  /** Номер договора ВЭД, не поставленного на учет в Банке */
  contractNum?: string;

  /**
   * Дата договора ВЭД, не поставленного на учет в Банке
   * @format date
   */
  contractDate?: string;

  /**
   * Id договора ВЭД
   * @format uuid
   */
  contractId?: string;
  attachments?: Attachment[];
  permissions?: PermissionResponse[];

  /** Комментарий к отказу или исполнению */
  bankInfoComment?: string;
}

/**
 * Настройка
 */
export interface Setting {
  code?: string;
  value?: string;
}

/**
 * Список настроек
 */
export interface SettingsResponse {
  settings?: Setting[];
}

/**
 * Разрешения на документ
 */
export interface PermissionsResponse {
  /** Тип документа */
  documentType?: string;

  /** Список разрешений для документа */
  permissions?: PermissionResponse[];
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Поля ККБ
 */
export type CcbFields = object;

/**
 * Документ
 */
export interface DocumentOrderCcbResponse {
  /** Тип документа */
  type?: DocumentTypeOrderCcbResponse;

  /** Поля ККБ */
  fields?: CcbFields;
}

/**
 * Тип документа
 */
export interface DocumentTypeOrderCcbResponse {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: DocumentOrderCcbResponse;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-currency-info
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Микросервис owb-ms-prd-currency-info <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Работа с документами "Заявление на выдачу информации ВК"
     * @name GetStatementDetail
     * @summary Получение деталей документа
     * @request GET:/api/currency-info/v1/external/statement/{id}
     * @secure
     */
    getStatementDetail: (id: string, params: RequestParams = {}) =>
      this.request<ClientStatementResponseDetail, GenericError>({
        path: `/api/currency-info/v1/external/statement/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с документами "Заявление на выдачу информации ВК"
     * @name UpdateStatement
     * @summary Редактирование
     * @request PUT:/api/currency-info/v1/external/statement/{id}
     * @secure
     */
    updateStatement: (
      id: string,
      data: StatementUpdate,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<StatementResponse, GenericError>({
        path: `/api/currency-info/v1/external/statement/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с документами "Заявление на выдачу информации ВК"
     * @name DeleteStatement
     * @summary Удаление
     * @request DELETE:/api/currency-info/v1/external/statement/{id}
     * @secure
     */
    deleteStatement: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/currency-info/v1/external/statement/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с документами "Заявление на выдачу информации ВК"
     * @name GetStatementList
     * @summary Получение списка документов
     * @request GET:/api/currency-info/v1/external/statement
     * @secure
     */
    getStatementList: (
      query?: {
        page?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        states?: string[];
        agreementId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientStatementResponseList, GenericError>({
        path: `/api/currency-info/v1/external/statement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с документами "Заявление на выдачу информации ВК"
     * @name CreateStatement
     * @summary Создание документа
     * @request POST:/api/currency-info/v1/external/statement
     * @secure
     */
    createStatement: (
      data: StatementRequest,
      query?: { isDraft?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<StatementResponse, GenericError>({
        path: `/api/currency-info/v1/external/statement`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки
     * @name GetSettings
     * @summary Список настроек
     * @request GET:/api/currency-info/v1/external/settings
     * @secure
     */
    getSettings: (params: RequestParams = {}) =>
      this.request<SettingsResponse, GenericError>({
        path: `/api/currency-info/v1/external/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Печать
     * @name Print
     * @summary Печать
     * @request GET:/api/currency-info/v1/external/report
     * @secure
     */
    print: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/currency-info/v1/external/report`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений на документ по его типу
     * @name GetPermissionByDocumentType
     * @summary Получение разрешений на документ
     * @request GET:/api/currency-info/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissionByDocumentType: (
      documentType: string,
      params: RequestParams = {}
    ) =>
      this.request<PermissionsResponse, void>({
        path: `/api/currency-info/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Download
     * @summary Получение файла
     * @request GET:/api/currency-info/v1/external/files/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/currency-info/v1/external/files/${id}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/currency-info/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError>({
        path: `/api/currency-info/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с сертификатами клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/currency-info/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, GenericError>({
        path: `/api/currency-info/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные ККБ документа
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/currency-info/v1/external/ccb/order-ccb
     * @secure
     */
    getOrderCcb: (query: { documentId: string }, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, ErrorMessage>({
        path: `/api/currency-info/v1/external/ccb/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
